var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.expected_delivery_date)?_c('div',[_c('span',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.$t('myLoads.myLoadsTable.edd')),expression:"$t('myLoads.myLoadsTable.edd')",modifiers:{"hover":true,"top":true}}],class:_vm.compareDatesEpd(
        _vm.params.expected_delivery_date,
        _vm.setLoadStatusColor(_vm.params.load_status)
      )},[_vm._v(" "+_vm._s(_vm._f("dateFormat")(_vm.params.expected_delivery_date))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }